import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import SettingsStore from "@/stores/SettingsStore";
import { useTranslation } from "react-i18next";
import { ControlWrapper } from "@/components/ui/control-wrapper";
import { Server, Key, Globe, Hash } from "lucide-react";

export function RealtimeApiConfig() {
  const { t } = useTranslation();
  const isLoading = SettingsStore(state => state.isLoading);

  const realtimeEndpoint = SettingsStore(state => state.realtimeEndpoint);
  const realtimeDeployment = SettingsStore(state => state.realtimeDeployment);
  const realtimeApiKey = SettingsStore(state => state.realtimeApiKey);
  const realtimeApiVersion = SettingsStore(state => state.realtimeApiVersion);

  const setRealtimeEndpoint = SettingsStore(state => state.setRealtimeEndpoint);
  const setRealtimeDeployment = SettingsStore(state => state.setRealtimeDeployment);
  const setRealtimeApiKey = SettingsStore(state => state.setRealtimeApiKey);
  const setRealtimeApiVersion = SettingsStore(state => state.setRealtimeApiVersion);

  return (
    <ControlWrapper>
      <div className="flex items-center gap-2 mb-4">
        <Server className="h-5 w-5 text-muted-foreground" />
        <h3 className="font-semibold">{t("realtimeApi.configTitle")}</h3>
      </div>
      <p className="text-sm text-muted-foreground mb-4">{t("realtimeApi.configDescription")}</p>
      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="realtime-endpoint" className="flex items-center gap-1.5">
            <Globe className="h-3.5 w-3.5" />
            {t("realtimeApi.endpoint")}
          </Label>
          <Input
            id="realtime-endpoint"
            value={realtimeEndpoint ?? ""}
            onChange={(e) => setRealtimeEndpoint(e.target.value)}
            placeholder="https://your-resource.openai.azure.com"
            disabled={isLoading}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="realtime-deployment" className="flex items-center gap-1.5">
            <Hash className="h-3.5 w-3.5" />
            {t("realtimeApi.deployment")}
          </Label>
          <Input
            id="realtime-deployment"
            value={realtimeDeployment ?? ""}
            onChange={(e) => setRealtimeDeployment(e.target.value)}
            placeholder="gpt-4o-realtime"
            disabled={isLoading}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="realtime-api-key" className="flex items-center gap-1.5">
            <Key className="h-3.5 w-3.5" />
            {t("realtimeApi.apiKey")}
          </Label>
          <Input
            id="realtime-api-key"
            type="password"
            value={realtimeApiKey ?? ""}
            onChange={(e) => setRealtimeApiKey(e.target.value)}
            placeholder={t("realtimeApi.apiKeyPlaceholder")}
            disabled={isLoading}
          />
          <p className="text-xs text-muted-foreground">{t("realtimeApi.apiKeyHint")}</p>
        </div>
        <div className="space-y-2">
          <Label htmlFor="realtime-api-version" className="flex items-center gap-1.5">
            <Hash className="h-3.5 w-3.5" />
            {t("realtimeApi.apiVersion")}
          </Label>
          <Input
            id="realtime-api-version"
            value={realtimeApiVersion ?? "2024-12-17"}
            onChange={(e) => setRealtimeApiVersion(e.target.value)}
            placeholder="2024-12-17"
            disabled={isLoading}
          />
          <p className="text-xs text-muted-foreground">{t("realtimeApi.apiVersionHint")}</p>
        </div>
      </div>
    </ControlWrapper>
  );
}
